import React from "react";
import Integrationscard from "components/integration-card";
import { EvtSectionHeader } from "components/header";
import { PROJECT_INTEGRATION_TYPES } from "../../context";
import { useDiscordData } from "./discord/useDiscordData";
import { useDriveData } from "./drive/useDriveData";
import { useGithubData } from "./github/useGithubData";
import { ROUTE } from "@/lib/utils";
import { LINKS, DISCORD_GUILD_ID } from "@/lib/utils";

export default function ActiveIntegration({ project_slug, id }) {
  const { discordChannelIds } = useDiscordData(id);
  const { driveFolderIds } = useDriveData(id);
  const { githubRepos } = useGithubData(id);

  const hasAny =
    discordChannelIds.length > 0 ||
    driveFolderIds.length > 0 ||
    githubRepos.length > 0;

  if (!hasAny) return null;

  return (
    <section className="mt-2 pb-3">
      <EvtSectionHeader title="Active Integrations" />
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-2 px-4 gap-4 md:px-6 mt-2.5">
        {discordChannelIds.map(({ channelId, chat_id, project_service_id }) => (
          <Integrationscard
            key={`discord-${chat_id}`}
            title={project_slug}
            icon={PROJECT_INTEGRATION_TYPES.discord.icon}
            href={ROUTE.PROJECT_INTEGRATIONS_CHAT_SERVICE(
              project_slug,
              project_service_id,
              chat_id
            )}
            link={LINKS.DISCORD_CHANNEL(DISCORD_GUILD_ID, channelId)}
          />
        ))}
        {driveFolderIds.map(({ folderId, drive_id, project_service_id }) => (
          <Integrationscard
            key={`drive-${drive_id}`}
            title={project_slug}
            icon={PROJECT_INTEGRATION_TYPES.drive.icon}
            href={ROUTE.PROJECT_INTEGRATIONS_DRIVE_SERVICE(
              project_slug,
              project_service_id,
              drive_id
            )}
            link={LINKS.DRIVE_FOLDER_WEB(folderId)}
          />
        ))}

        {githubRepos.map(({ repository_url, repo_id, project_service_id }) => (
          <Integrationscard
            key={`github-${repo_id}`}
            title={repository_url.split("/").slice(-2).join(" / ")}
            icon={PROJECT_INTEGRATION_TYPES.github.icon}
            href={ROUTE.PROJECT_INTEGRATIONS_REPOSITORY_SERVICE(
              project_slug,
              project_service_id,
              repo_id
            )}
            link={repository_url}
          />
        ))}
      </div>
    </section>
  );
}
